export const BRAND = {
  name: "로스트랩",
  nameEn: "ROAST LAB",
  tagline: "specialty roaster & drip bar based in seongsu",
  email: "hello@roast-lab.co.kr",
  address: "서울 성동구 연무장길 45",
  phone: "02-465-3300",
  hours: "10:00 – 21:00 · 월요일 휴무",
};

export const NAV = [
  { id: "works", label: "menu" },
  { id: "about", label: "story" },
  { id: "visit", label: "visit" },
];

export const MARQUEE = "roast • pour • bloom • roast • pour • bloom • roast • pour • bloom";

export const HERO = {
  year: "2026",
  label: "roast reel",
  title: "single origin, slow poured",
  subtitle: "성수동 로스터리에서 매일 소량 배치로 굽는 원두의 결을 영상처럼 담았습니다.",
};

export const WORKS = [
  { id: 1, title: "ethiopia yirgacheffe", tag: "light · floral", tone: "linear-gradient(135deg,#3d2914 0%,#8b5a2b 50%,#d4a574 100%)" },
  { id: 2, title: "colombia huila", tag: "medium · caramel", tone: "linear-gradient(135deg,#1a1209 0%,#5c3d2e 55%,#c49a6c 100%)" },
  { id: 3, title: "guatemala antigua", tag: "medium · cocoa", tone: "linear-gradient(135deg,#0f0a07 0%,#4a3228 50%,#9a7b5c 100%)" },
  { id: 4, title: "kenya aa", tag: "bright · berry", tone: "linear-gradient(135deg,#1c0f14 0%,#6b2d3c 45%,#c97b8a 100%)" },
  { id: 5, title: "seasonal blend", tag: "house · balanced", tone: "linear-gradient(135deg,#14100c 0%,#3d3428 50%,#8a7a62 100%)" },
  { id: 6, title: "cold brew reserve", tag: "18h · smooth", tone: "linear-gradient(135deg,#080808 0%,#1e1a16 55%,#4a4035 100%)" },
];

export const ABOUT = {
  lead: "원두 한 알의 가능성을 실험하는 스페셜티 로스터리.",
  body: [
    "로스트랩은 성수동 작은 공방에서 시작했습니다. 대량 생산 대신 소량 배치 로스팅, 표준 레시피 대신 매주 바뀌는 싱글 오리진.",
    "컵핑 테이블에서 맛을 기록하고, 드립 바에서 그 결을 한 잔씩 증명합니다. 카페가 아니라 로스터의 포트폴리오처럼, 메뉴도 작품처럼 쌓아갑니다.",
  ],
  stats: [
    { n: "12+", label: "origins / season" },
    { n: "48h", label: "peak after roast" },
    { n: "1kg", label: "max batch size" },
  ],
};

export const VISIT = {
  note: "walk-ins welcome · cupping class every saturday 14:00",
  transit: "성수역 2번 출구 도보 8분",
};
